import { createReducer, on } from "@ngrx/store";
import { Pagination } from "../../../domain/pagination.interface";
import { ValueState } from "../states/value.state";

import {
  loadValuesList,
  loadValuesListSuccess,
  loadValuesListFailure,
  getSelectedValue,
  getSelectedValueSuccess,
  getSelectedValueFailure
} from "../actions/value.actions";

export const initialPagination: Pagination = {
  total: 0,
  pages: 1,
  next: null,
  previous: null,
  current: 1,
  entries: 50,
};

export const initialState: ValueState = {
  values: null,
  selectedValue: null,
  error: null,
  listStatus: "pending",
  getStatus: "pending",
  pagination: initialPagination
};

export const valueReducer = createReducer(
  // Supply the initial state
  initialState, 
  // Handle list
  on(loadValuesList, (state) => ({
    ...state,
    listStatus: "loading" as ValueState["listStatus"],
  })),
  // Handle successfully list
  on(loadValuesListSuccess, (state, { data }) => {
    return {
      ...state,
      values: data.results,
      error: null,     
      pagination: data.pagination,
      listStatus: "success" as ValueState["listStatus"]
    }
  }),
  // Handle failure list
  on(
    loadValuesListFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    listStatus: "error" as ValueState["listStatus"],
  })),
  // Handle get selected
  on(getSelectedValue, (state) => ({
    ...state,
    getStatus: "loading" as ValueState["getStatus"],
  })),
  // Handle successfully get selected
  on(getSelectedValueSuccess, (state, { value }) => {    
    return {
      ...state,
      selectedValue: value,
      error: null,
      getStatus: "success" as ValueState["getStatus"]
    }
  }),
  // Handle failure get
  on(
    getSelectedValueFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    getStatus: "error" as ValueState["getStatus"],
  })),
   
);

